<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="loadData(1)">刷新</el-button>
            </div>
            <div class="header-right" style="align-items: center;">
                <el-checkbox v-model="showEmpty" style="margin-right: 12px;" @change="afterInitialData">显示空行</el-checkbox>
                <!-- <el-date-picker v-model="dateFilter.start" type="date" class="header-input" @input="$forceUpdate()" placeholder="选择起始日期" style="width: 180px;" @change="loadData"></el-date-picker>
                <el-date-picker v-model="dateFilter.end" type="date" class="header-input" @input="$forceUpdate()" placeholder="选择终止日期" style="width: 180px;" @change="loadData"></el-date-picker>
                <el-button type="primary" @click="loadData()">搜索</el-button> -->
            </div>
        </div>
        <el-table :data="filterRecords" border style="width: 100%">
            <el-table-column label="序号" width="70">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="gradeName" label="评级公司名称"></el-table-column>
            <el-table-column label="当前库存(数量/总金额)">
                <template slot-scope="scope">
                    {{ scope.row.resalerCount1234 + "枚 | " + scope.row.resalerTotal1234 +  "元" }}
                </template>
            </el-table-column>
            <el-table-column label="锁定(数量/总金额)">
                <template slot-scope="scope">
                    {{ scope.row.resalerCount5 + "枚 | " + scope.row.resalerTotal5 +  "元" }}
                </template>
            </el-table-column>
            <el-table-column label="出库(数量/总金额)">
                <template slot-scope="scope">
                    {{ scope.row.resalerCount6 + "枚 | " + scope.row.resalerTotal6 +  "元" }}
                </template>
            </el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.gradeDate) }}
                </template>
            </el-table-column>
            <el-table-column prop="gradeMemo" label="评级公司备注"></el-table-column>
            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="addressOpen(scope.row.gradeId, scope.row.gradeName)" type="text" size="small">库存详情</el-button>
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40, 100, 500]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div> -->
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="110px">
                    <el-form-item label="评级公司名称">
                        <el-input v-model="handleInfo.gradeName"></el-input>
                    </el-form-item>
                    <el-form-item label="评级公司备注">
                        <el-input v-model="handleInfo.gradeMemo"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="addressTitle" :visible.sync="addressLayer" width="450px" :close-on-click-modal="false">
             <el-descriptions :column="1" border>
                <el-descriptions-item :label-style="{width: '150px'}" v-for="address in addresses">
                    <template slot="label">
                        {{ address.addressName }}
                    </template>
                    {{ address.productCount }}枚
                </el-descriptions-item>
            </el-descriptions>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addressLayer = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import enumMixin from "@/mixins/enum-mixin.js"
import { API, doGet } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin, enumMixin],
    data: function () {
        return {
            showEmpty: true,
            addressTitle: "",
            addressLayer: false,
            addresses: [],
            filterRecords: [],
            dateFilter: {
                start: "",
                end: ""
            }
        }
    },
    methods: {
        initialParam: function() {
            this.filterParams.startDate = this.dateFilter.start.getTime() / 1000;
            this.filterParams.endDate = this.dateFilter.end.getTime() / 1000;
        },
        afterInitialData: function() {
            this.filterRecords = [];
            for (let i = 0; i < this.records.length; i++) {
                if (this.showEmpty || this.records[i].resalerCount1234 > 0 || this.records[i].resalerCount5 > 0 || this.records[i].resalerCount6 > 0) {
                    this.filterRecords.push(this.records[i]);
                }
            }
        },
        addressOpen: async function(gradeId, gradeName) {
            this.addressTitle = "【" + gradeName + "】库存详情";
            this.addresses = await doGet(API.ADDRESS.GRADE, { gradeId: gradeId });
            this.addressLayer = true;
        },
    },
    created: async function () {
        let now = new Date();
        this.dateFilter.start = new Date(now.getFullYear(), now.getMonth(), 1);
        this.dateFilter.end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        this.size = 1000;
        this.tag = "GRADE";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>